/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choose_PreviousInputs */

const en_plan_choose_previous = /** @type {(inputs: Plan_Choose_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved plans`)
};

const id_plan_choose_previous = /** @type {(inputs: Plan_Choose_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencana tersimpan`)
};

/**
* | output |
* | --- |
* | "Saved plans" |
*
* @param {Plan_Choose_PreviousInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const plan_choose_previous = /** @type {((inputs?: Plan_Choose_PreviousInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choose_PreviousInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_plan_choose_previous(inputs)
	return en_plan_choose_previous(inputs)
});